export const ApprovalStatusSelectOptions = () => [
    {
        id: 0,
        label: "Rejected",
    },
    {
        id: 1,
        label: "Approved",
    },
    {
        id: 2,
        label: "Further evidence required",
    },
];